// @flow
import React, {Component} from 'react';
import {StyleSheet, View, Platform, ScrollView, SafeAreaView} from 'react-native';

import {
  GradientPage,
  FullButton,
  DownloadAppOnStore,
} from '../../../components/common';
import PageTitle from '../../../components/signUp/PageTitle';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import SIMRadioButton from './components/SIMRadioButton';

class SimOrEsim extends Component<Props, State> {
  styles = getStyles();
  state = {
    showDownloadableZone: Platform.OS === 'web' ? true : false,
  };

  onSimSelect = () => {
    this.props.selectEsim(false);
  };

  onEsimSelect = () => {
    this.props.selectEsim(true);
  };

  goToNextPage = () => {
    if (Platform.OS === 'web') {
      this.props.initSignUp();
      return;
    } else if (this.props.eSimSelected) {
      this.props.goTo('eSimCheck', this.props.route.params ?? {});
    } else {
      this.props.goToNextOrderPage(this.props.nextPage);
    }
  };

  render() {
    const styles = this.styles;
    const {eSimSelected} = this.props;

    return (
      <GradientPage iosEdges={['top', 'bottom']} maxWidth={670}>
        {/* SafeView/Flex container to wrap everything */}
        <View style={styles.mainContainer}>
          
          <ScrollView 
            style={styles.scrollView}
            // This is the key to fixing scroll behavior issues
            contentContainerStyle={styles.scrollContent}
            showsVerticalScrollIndicator={false}
          >
            <PageTitle
                title={I18n.t('SignUp.SimOrEsim.title')}
                style={styles.title}/>

            <View style={styles.radiosContent}>
              <SIMRadioButton
                disabled={false}
                isActive={!eSimSelected}
                label={I18n.t('SignUp.SimOrEsim.simTypeLabel')}
                description={I18n.t('SignUp.SimOrEsim.simDetail1')}
                topRightImageName={theme.simCardImage}
                onSelect={this.onSimSelect}
              />

              <View style={styles.spacer} />

              <SIMRadioButton
                disabled={Platform.OS === 'web'}
                isActive={eSimSelected}
                label={I18n.t('SignUp.SimOrEsim.eSimTypeLabel')}
                description={I18n.t('SignUp.SimOrEsim.eSimDetail1')}
                topRightImageName={theme.eSimImage}
                onSelect={this.onEsimSelect}
              />
            </View>
          </ScrollView>

          {/* Bottom Pinned Area */}
          <View style={styles.footer}>
            {this.state.showDownloadableZone && (
              <View style={styles.downloadZone}>
                <View style={styles.line} />
                <DownloadAppOnStore />
              </View>
            )}
            
            <View style={styles.buttonZone}>
              <FullButton
                text={I18n.t('SignUp.SimOrEsim.buttonConfirm')}
                onPress={this.goToNextPage}
                style={styles.button}
                textStyle={styles.buttonText}
                disabled={false}
                testID={'simOrEsim-confirm-button'}
              />
            </View>
          </View>
        </View>
      </GradientPage>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    mainContainer: {
      flex: 1,
    },
    scrollView: {
      flex: 1,
    },
    scrollContent: {
      flexGrow: 1, // Ensures content can be larger than screen
      paddingHorizontal: 25,
      paddingTop: Platform.OS === 'ios' ? 20 : 30,
      paddingBottom: 20,
    },
    title: {
      fontSize: Platform.OS === 'ios' ? 22 : 25,
      marginHorizontal: 0, // Reset since parent has padding
    },
    radiosContent: {
      flexDirection: 'column',
      marginTop: 40, // Reduced from 80 for better small-screen fit
    },
    spacer: {
      height: 20,
    },
    footer: {
      backgroundColor: 'transparent',
      paddingBottom: Platform.OS === 'ios' ? 20 : 10,
    },
    buttonZone: {
      paddingVertical: 10,
    },
    button: {
      marginHorizontal: 20,
    },
    buttonText: {
      fontSize: 16,
      fontWeight: '500',
    },
    downloadZone: {
      alignItems: 'center',
    },
    line: {
      height: 1,
      width: '90%',
      marginVertical: 20,
      backgroundColor: theme.signUpInputTextColor,
      opacity: 0.3,
    },
  });
}

export default SimOrEsim;